import Shared from "./shared";

export default async (to, from, next) => {
    let hyperlinkId: string = to.params.hyperlink_id;

    let url = `${Shared.iProvaUrl}/Management/HyperlinkLoader.aspx?HyperlinkID=${hyperlinkId}&new=1`;
    window.open(url, "_blank");
    next(false); //abort the current navigation
};
